import script from "./ArrayEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrayEditor.vue?vue&type=script&setup=true&lang=js"

import "./ArrayEditor.vue?vue&type=style&index=0&id=c3ee29fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3ee29fc"]])

export default __exports__